export default function NoDefault(){
    return <h1>404 errro</h1>
}